// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1664":"b88458fdef496242","1698":"73a64d3b99cc8349","4896":"84f6640a228a67d3","5249":"f4bb54701f5b1c06","5259":"fc301960a33d88b1","8199":"f01407468f07465e"}[chunkId] + ".css";
};